import PsychologyIcon from '@mui/icons-material/Psychology';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { useAiChatReply } from '../../../../sic-lib/api/hooks/useAi';
import { ChannelType } from '../../../../sic-lib/enums/ChannelType';
import { resetAiSuggestion, setContactComposeMessage } from '../../../../store/conversation';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { useUserHasDialerSetup, useUserHasPackageFeatureAi } from '../../../../store/users';

interface Props {
    contactId: number;
}

export default function AiGenerateReply({ contactId }: Props) {
    const dispatch = useAppDispatch();

    const webSocketConnectionId = useAppSelector(state => state.websocket.connectionId);
    const suggestReplyChannelIndexId = useAppSelector(
        state => state.conversation.suggestReplyChannelIndexId,
    );

    const hasDialerSetup = useUserHasDialerSetup();
    const hasAiAutoReply = useUserHasPackageFeatureAi();

    const { refetch, isFetching } = useAiChatReply({
        contactId: contactId,
        channelType: ChannelType.messageEvents,
        websocketConnectionId: webSocketConnectionId,
        channelIndexId: suggestReplyChannelIndexId,
    });

    const handleSuggest = () => {
        if (isFetching) return;
        dispatch(resetAiSuggestion({ contactId }));
        dispatch(setContactComposeMessage({ contactId, subject: '', body: '', media: [] }));
        refetch();
    };

    if (!hasAiAutoReply) return null;

    return (
        <Tooltip title="Generate Smart Reply">
            <IconButton onClick={handleSuggest}>
                {isFetching ? <CircularProgress size={24} /> : <PsychologyIcon />}
            </IconButton>
        </Tooltip>
    );
}
